import request from '@/utils/httpRequest'

export default class QualityPlanService {
  queryQualityPlanById(id) {
    return request({
      url: '/quality/wuyeQualityPlan/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/quality/wuyeQualityPlan/startFlow',
      method: 'post',
      data: params
    })
  }
}
